import { request } from '@/shared/api/request'

export const getMismatch = (data) => {
	return request({ url: `contract/discrepancies/get`, method: 'get', params: data })
}

export const getMismatchXsl = (data) => {
	return request({ url: `contract/discrepancies/xsl`, method: 'get', params: data, responseType: 'blob' })
}